module.exports = "<ul class=\"breadcrumb\" [ngClass]=\"getClasses()\">\n  <li *ngFor=\"let item of menu; let last = last\">\n    <a href=\"item.link\" *ngIf=\"item.link\"><span class=\"icon {{item.icon}}\" *ngIf=\"item.icon\"></span>{{item.title}}</a><!--\n    --><span class=\"static\" *ngIf=\"!item.link\"><span class=\"icon {{item.icon}}\" *ngIf=\"item.icon\"></span>{{item.title}}</span><!--\n    --><span class=\"separator\" *ngIf=\"!last\">{{separator}}</span>\n  </li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/common-components/breadcrumb/breadcrumb.component.html
// module id = ./src/app/home/common-components/breadcrumb/breadcrumb.component.html
// module chunks = main